(function () {
class $79579bfa9b0b293e$export$813aeeff790704a9 {
    constructor(selector){
        const self = this;
        self.selector = selector;
        self.widgetId = null;
        self.token = null;
    }
    initCaptcha(_ReCaptchaSiteKey) {
        const self = this;
        const container = document.querySelector(self.selector);
        if (!container) {
            console.error('ReCaptcha container not found!');
            return;
        }
        // Ensure the reCaptcha API is loaded
        if (typeof grecaptcha === 'undefined') {
            console.warn('reCAPTCHA not loaded yet. Retrying...');
            setTimeout(()=>this.initCaptcha(), 100);
            return;
        }
        // Render reCaptcha widget
        try {
            self.widgetId = grecaptcha.render(container, {
                sitekey: _ReCaptchaSiteKey,
                callback: self.onVerify.bind(self),
                "expired-callback": self.onExpired.bind(self)
            });
        } catch (error) {
            console.error("Error rendering reCAPTCHA:", error);
        }
    }
    onVerify(token) {
        const self = this;
        self.token = token; // Reset the captcha if it expires
    }
    onExpired() {
        const self = this;
        console.warn('reCaptcha expired, re-rendering...');
        self.token = null;
        grecaptcha.reset(this.widgetId);
    }
}


const $cd55a0189722a037$var$SELECTORS = Object.freeze({
    NOTIFICATION_CLASS: 'field-error-message text-danger field-validation-error mt-2 js-recaptha-notification active',
    CAPTCHA_SELECTOR: '.js-captcha',
    SUBMIT_BUTTON_SELECTOR: '#registerSubmit',
    RECAPTCHA_INPUT_SELECTOR: '.g-recaptcha-input'
});
const $cd55a0189722a037$var$createNotification = (message, className)=>{
    const notification = document.createElement('div');
    notification.textContent = message;
    className.split(' ').forEach((cls)=>notification.classList.add(cls));
    notification.style.display = 'none'; // Initially hidden
    return notification;
};
const $cd55a0189722a037$var$insertNotification = (form, notification, captchaSelector, submitSelector)=>{
    const captchaElement = form.querySelector(captchaSelector);
    const submitElement = form.querySelector(submitSelector);
    if (captchaElement && captchaElement.nextSibling) captchaElement.parentNode.insertBefore(notification, captchaElement.nextSibling);
    else if (submitElement) submitElement.parentNode.insertBefore(notification, submitElement);
    else form.appendChild(notification); // Fallback
};
const $cd55a0189722a037$var$getOrCreateNotification = (form, message, className, captchaSelector, submitSelector)=>{
    const existingNotification = form.querySelector(`.js-recaptha-notification`);
    if (existingNotification) return existingNotification;
    const newNotification = $cd55a0189722a037$var$createNotification(message, className);
    $cd55a0189722a037$var$insertNotification(form, newNotification, captchaSelector, submitSelector);
    return newNotification;
};
function $cd55a0189722a037$var$waitForReCaptcha(callback) {
    if (typeof grecaptcha === "object" && typeof grecaptcha.render === "function") callback();
    else {
        console.warn("reCAPTCHA API not ready or incomplete. Retrying...");
        setTimeout(()=>$cd55a0189722a037$var$waitForReCaptcha(callback), 100);
    }
}
function $cd55a0189722a037$var$toggleVisibility(container, state) {
    if (state) container.style.display = "block";
    else container.style.display = "none";
}
const $cd55a0189722a037$export$56f1f47f5091ea99 = (selector, reCaptchaComponent, options = {})=>{
    const form = document.querySelector(selector);
    if (!form) {
        console.error(`Form with selector "${selector}" not found.`);
        return;
    }
    const { captchaSelector: captchaSelector = $cd55a0189722a037$var$SELECTORS.CAPTCHA_SELECTOR, submitSelector: submitSelector = $cd55a0189722a037$var$SELECTORS.SUBMIT_BUTTON_SELECTOR, notificationClass: notificationClass = $cd55a0189722a037$var$SELECTORS.NOTIFICATION_CLASS, notificationMessage: notificationMessage = 'Please complete the reCAPTCHA.' } = options;
    form.addEventListener("submit", async (event)=>{
        event.preventDefault();
        const token = reCaptchaComponent.token;
        if (!token) {
            const notification = $cd55a0189722a037$var$getOrCreateNotification(form, notificationMessage, notificationClass, captchaSelector, submitSelector);
            $cd55a0189722a037$var$toggleVisibility(notification, true);
            return;
        }
        const reCaptchaInput = form.querySelector(".g-recaptcha-input");
        reCaptchaInput.value = token;
        form.submit();
    });
};
function $cd55a0189722a037$var$renderCaptcha(selector) {
    const reCaptcha = new (0, $79579bfa9b0b293e$export$813aeeff790704a9)(selector);
    reCaptcha.initCaptcha(_ReCaptchaSiteKey);
    return reCaptcha;
}
document.addEventListener('DOMContentLoaded', ()=>{
    $cd55a0189722a037$var$waitForReCaptcha(()=>{
        const reCaptcha = $cd55a0189722a037$var$renderCaptcha(".js-captcha");
        if (!reCaptcha) {
            console.error("Failed to initialize reCAPTCHA. Please check configuration.");
            return;
        }
        $cd55a0189722a037$export$56f1f47f5091ea99("#registerForm", reCaptcha);
    });
});

})();
//# sourceMappingURL=register.js.map
